import { AbstractControl, ValidationErrors } from "@angular/forms";
import { Observable, of, timer } from "rxjs";
import { catchError, first, map, switchMap } from "rxjs/operators";
import { BaseProductGateway } from "../gateways";
import { codeGenerator } from "../helpers";

export const uniqueProductNameValidator = (
    gateway: BaseProductGateway,
    originalName: string,
    originalCode: string,
    isNew: boolean
) => {
    return (
        control: AbstractControl
    ): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
        if (!control.value || originalName === control.value) return of(null);

        const name = control.value;
        const code = isNew ? codeGenerator(control.value, "Product") : originalCode;

        return timer(300).pipe(
            switchMap(() => gateway.checkDuplicity(name, code)),
            map(result => {
                const codeTaken = isNew ? result.codeTaken : false;
                const nameTaken = result.nameTaken;

                return nameTaken || codeTaken ? { codeTaken, nameTaken } : null;
            }),
            catchError(() => of(null)),
            first()
        );
    };
};
